(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sparezone-header"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    customElements.define(
      'sticky-header',
      class extends HTMLElement {
        connectedCallback() {
          const section = this.closest('.shopify-section') || this;
          section.classList.add('shopify-section-header-sticky');
          document.documentElement.style.setProperty('--header-height', `${section.offsetHeight}px`);
        }
      }
    );
  }

  document.querySelectorAll('[data-sz-menu]').forEach((button) => {
    const drawer = document.getElementById(button.getAttribute('aria-controls'));
    if (!drawer || button.dataset.szMenuBound === 'true') return;
    button.dataset.szMenuBound = 'true';

    // Keep the drawer at the document root so fixed positioning is never clipped.
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    const panel = drawer.querySelector('.sz-drawer__panel');
    const closeButtons = drawer.querySelectorAll('[data-sz-drawer-close]');
    let closeTimer;

    const setOpen = (open) => {
      window.clearTimeout(closeTimer);
      button.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('sz-drawer-open', open);
      document.body.classList.toggle('sz-drawer-open', open);

      if (open) {
        drawer.hidden = false;
        // Allow the browser to apply the closed transform before opening.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            drawer.classList.add('is-open');
            const focusable = panel.querySelector('a, button:not(.sz-drawer__overlay)');
            if (focusable) focusable.focus({ preventScroll: true });
          });
        });
      } else {
        drawer.classList.remove('is-open');
        closeTimer = window.setTimeout(() => {
          drawer.hidden = true;
          button.focus({ preventScroll: true });
        }, 300);
      }
    };

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setOpen(button.getAttribute('aria-expanded') !== 'true');
    });

    closeButtons.forEach((el) => {
      el.addEventListener('click', () => setOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
      }
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.sz-nav__details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
